if ( typeof PartnerRecommendations !== 'function' ) {

  class PartnerRecommendations extends HTMLElement {
    constructor() {
			super();

      this.holder = this.querySelector('[data-partner-recommendations]');
    }

    connectedCallback() {
      document.addEventListener("theme:partner:render", (evt) => {
        this.partner = evt.detail.partner;
        if (this.rendering) return;
        this.renderRecommendations();
      });
      document.addEventListener("theme:partner:update", (evt) => {
        this.partner = evt.detail.partner;
        if (this.rendering) return;
        this.renderRecommendations();
      })
    }

    async renderRecommendations() {
      this.rendering = true;
      this.classList.add('hidden');

      try {
        this.recommendationsData = await window.backend.getFeaturedProducts(this.partner.id);
        if (!this.recommendationsData?.featuredProducts?.length) return;
        this.recommendations = this.recommendationsData.featuredProducts;
        
        const promisesArr = this.fetchRecommendationPromises();
  
        Promise
          .all(promisesArr)
          .then((markupArr) => {
            const markupMerged = markupArr.reduce((a, b) => a + b);
            this.holder.innerHTML = markupMerged;
            // init carousel
            this.classList.remove('hidden');
            this.dispatchEvent(new CustomEvent("theme:partner-recommendations:added", {
              bubbles: true
            }));
            this.rendering = false;
          })
          .catch((error) => {
            console.warn(error);
          });
      } catch (e) {
        console.error(e);
      }
    }

    fetchRecommendationPromises() {
      return this.recommendations.map((item) => {
        const variantId = parseFloat(item.productVariantId.replace('gid://shopify/ProductVariant/', '')); 

        return new Promise((resolve, reject) => {
          window
            .fetch(`${window.theme.routes.root_url}variants/${variantId}/?section_id=api-partner-recommendation-item`)
            .then((response) => {
              return response.text();
            })
            .then((response) => {
              // handle success
              const fresh = document.createElement('div');
              fresh.innerHTML = response;
              const freshInner = fresh.querySelector('[data-api-content]').innerHTML;
              const freshOuter = `
               <div 
                  data-carousel-slide 
                  data-item
                  class="grid__item product-grid-slide">
                  ${freshInner}
                </div>
              `
              resolve(freshOuter);
            })
            .catch((error) => {
              reject(error);
            })
        })
      })
    }
  }

  if ( typeof customElements.get('partner-recommendations') == 'undefined' ) {
		customElements.define('partner-recommendations', PartnerRecommendations);
	}
}